import { Logger } from './logger';

type GtagFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: IArguments[];
    gtag?: GtagFn;
  }
}

let bootstrapped = false;

const pushGtagArgs = function pushGtagArgs(this: void) {
  window.dataLayer!.push(arguments);
};

export const ensureGtagBootstrap = (anyValidId: string): void => {
  if (typeof window === 'undefined' || bootstrapped) {
    return;
  }

  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || pushGtagArgs;
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(anyValidId)}`;
    script.dataset.pureboxAnalytics = 'gtag';
    document.head.appendChild(script);

    window.gtag('js', new Date());
    bootstrapped = true;
  } catch (error) {
    Logger.warn('Failed to bootstrap gtag.js', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
};

export const __resetGtagCoreForTests = (): void => {
  bootstrapped = false;
};
